//var DomParser = require('react-native-html-parser').DOMParser

export const htmlDecode = (input: any) => {
  var plainString = input.replace(/<[^>]+>/g, '');
  //let doc = new DOMParser().parseFromString(input, 'text/html');
  //let doc = new DomParser().parseFromString(input, 'text/html');
  return plainString;
};
